import React, { useState } from 'react'
import fetchData from '../../modules/fetch-data'
import { Async } from 'react-async'
import errorLog from '../../modules/error-log'
import useInterval from '../../modules/react-interval'

const pingData = {
  lastArticle: null,
  allArticles: null,
  error: false,
}

const ContextArticles = React.createContext(pingData)

const ArticlesProvider = ({ children, ...props }) => {
  const [contextError, setContextError] = useState(pingData.error)
  const [contextArticle, setContextArticle] = useState(pingData.lastArticle)
  const [contextArticles, setContextArticles] = useState(pingData.allArticles)
  const [pings, setPings] = useState(0)

  useInterval(() => setPings((pings) => pings + 1), 30000)
  return (
    <Async promiseFn={fetchData} location="newsticker" watch={pings}>
      {({ isFulfilled, data, error }) => {
        if (isFulfilled && data && data.data && data.data.articles.length > 0) {
          setContextArticle(data.data.articles[0])
          setContextArticles(data.data.articles)
        }

        if (!contextError != !error) {
          errorLog({
            error,
            info: 'stopped and failed requesting NewNewsMessage for navigator',
          })
          setContextError(error)
        }

        return (
          <ContextArticles.Provider
            value={{ lastArticle: contextArticle, error: contextError, allArticles: contextArticles }}
            {...props}
          >
            {children}
          </ContextArticles.Provider>
        )
      }}
    </Async>
  )
}

export default ContextArticles

export { ArticlesProvider }
